import React from "react";
import { TESTIMONIALS } from "../mock";
import { Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section className="relative bg-[var(--lc-cream)] py-20 lg:py-28">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="eyebrow text-[var(--lc-moss)] mb-5">Member Stories</div>
          <h2 className="font-serif-display text-[clamp(34px,5vw,68px)] leading-[1] font-light">
            Real results from <span className="italic">real Swiss members.</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-4 lg:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              className="relative bg-white border border-[var(--lc-line)] rounded-md p-8 lg:p-10 hover:shadow-lg transition-shadow"
            >
              <Quote className="h-7 w-7 text-[var(--lc-moss)]/30 absolute top-6 right-6" />
              <p className="font-serif-display text-[22px] lg:text-[26px] leading-[1.25] text-[var(--lc-ink)]">
                “{t.quote}”
              </p>
              <div className="mt-8 pt-5 border-t border-[var(--lc-line)] flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[var(--lc-moss)] grid place-items-center font-serif-display text-base text-white">
                  {t.name[0]}
                </div>
                <div>
                  <div className="text-sm font-semibold">{t.name}</div>
                  <div className="text-xs text-[var(--lc-muted)]">{t.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
